module.exports = __webpack_public_path__ + "static/media/3.3641c442.jpg";